import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";


@Component({
   selector: 'app-dialog-confirm-alt',
   templateUrl: './dialog-confirm-alt.component.html',
   styleUrls: ['./dialog-confirm-alt.component.scss']
})
export class DialogConfirmAltComponent implements OnInit {
   msg:string
   title:string
   show_confirm:boolean
   show_confirm_alt:boolean
   show_confirm_alt_red:boolean
   btn_cancel:string
   btn_confirm:string
   btn_confirm_alt:string
   btn_confirm_alt_red:string

   constructor(@Inject(MAT_DIALOG_DATA)
               public data: {title:string, msg:string, btn_confirm:string,
      btn_confirm_alt:string, btn_cancel:string, btn_confirm_alt_red:string, show_confirm:boolean,
      show_confirm_alt:boolean, show_confirm_alt_red:boolean}) {
      this.title = data.title || ''
      this.msg = data.msg || ''
      this.btn_cancel = data.btn_cancel || `Annulla`
      this.btn_confirm = data.btn_confirm || 'Conferma'
      this.btn_confirm_alt = data.btn_confirm_alt || 'Conferma'
      this.btn_confirm_alt_red = data.btn_confirm_alt_red || 'Conferma'
      this.show_confirm = data.show_confirm
      this.show_confirm_alt = data.show_confirm_alt
      this.show_confirm_alt_red = data.show_confirm_alt_red
   }

   ngOnInit(): void {

   }

}
